import { render, staticRenderFns } from "./Order2.vue?vue&type=template&id=75991108&"
import script from "./Order2.vue?vue&type=script&lang=js&"
export * from "./Order2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports